import api from './api';

const ENDPOINT = 'point-transactions/';

export default {
  get: (clientId, params = null) => api.get(`${ENDPOINT}get-by-client/${clientId}`, { params }),
  getTypes: () => api.get(`${ENDPOINT}types`),
};
